@let p = profile();
@let bioText = (p?.bio | translateData) || '';
@let addressText = (p?.address | translateData) || '';
<article class="architect-profile-card">
  <div class="architect-profile-card__media">
    <img
      class="architect-profile-card__logo"
      [ngSrc]="
        (p?.logo ?? '')
          | imageSource: true : 'md' : logoPlaceholder
      "
      [width]="120"
      [height]="120"
      [alt]="p?.title | translateData" />
  </div>
  <div class="architect-profile-card__body">
    <div class="architect-profile-card__heading">
      <div class="architect-profile-card__heading-main">
        @if (showFirstName()) {
          <p class="architect-profile-card__first-name">
            {{ firstName() }}
          </p>
        }
        @if ((p?.title | translateData); as profileTitle) {
          @if (profileTitle && profileTitle !== '-') {
            <h3 class="architect-profile-card__title">
              {{ profileTitle }}
            </h3>
          }
        }
      </div>
      <span class="architect-profile-card__type">{{ typeTranslationKey() | translate }}</span>
    </div>
    @if (p?.exact_role) {
      <p class="architect-profile-card__role">{{ p.exact_role }}</p>
    }
    @if (showBio(bioText)) {
      <p
        class="architect-profile-card__bio"
        [class.people-profile-card-locked]="isBioLocked(bioText)">
        @if (isBioLocked(bioText)) {
          {{ bio(bioText) }}
        } @else {
          {{ bioText.length > 130 ? bioText.slice(0, 130) + '…' : bioText }}
        }
      </p>
    }
    <div class="architect-profile-card__meta">
      @if (showRegion()) {
        <span
          class="architect-profile-card__meta-item"
          [class.people-profile-card-locked]="isRegionLocked()">
          📍 {{ region() }}
        </span>
      }
      @if (showAddress(addressText)) {
        <span
          class="architect-profile-card__meta-item architect-profile-card__meta-address"
          [class.people-profile-card-locked]="isAddressLocked(addressText)">
          @if (isAddressLocked(addressText)) {
            {{ address(addressText) }}
          } @else {
            {{ addressText.length > 45 ? addressText.slice(0, 45) + '…' : addressText }}
          }
        </span>
      }
    </div>
    @if (showContact()) {
      <div class="architect-profile-card__contact">
        @if (email(); as contactEmail) {
          @if (isEmailLocked()) {
            <span class="architect-profile-card__contact-link people-profile-card-locked">
              {{ contactEmail }}
            </span>
          } @else {
            <a
              [href]="'mailto:' + contactEmail"
              class="architect-profile-card__contact-link">
              {{ contactEmail }}
            </a>
          }
        }
        @if (phone(); as contactPhone) {
          <span
            class="architect-profile-card__contact-phone"
            [class.people-profile-card-locked]="isPhoneLocked()">
            {{ contactPhone }}
          </span>
        }
      </div>
    }
    @if ((p?.categories?.length ?? 0) > 0) {
      <div class="architect-profile-card__tags">
        @for (cat of (p?.categories ?? []).slice(0, 4); track cat._id) {
          <span class="architect-profile-card__tag">{{ cat?.title | translateData }}</span>
        }
      </div>
    }
    <div class="architect-profile-card__badges">
      @if (p?.bim_ready) {
        <span class="architect-profile-card__badge architect-profile-card__badge--bim">BIM ready</span>
      }
      @if ((p?.company_certifications?.length ?? 0) > 0) {
        <span class="architect-profile-card__badge">{{ (p?.company_certifications ?? []).length }} {{ 'industries.certificates' | translate }}</span>
      }
    </div>
  </div>
</article>
